export interface SignupAuth {
  _id?: string;
  name?: string;
  activated?: boolean;
  selfServeSignup?: { version?: number; status?: string; environment?: 'production' | 'staging'; emailVerifiedAt?: string };
  user?: { _id?: string; name?: string; username?: string; accessLevel?: string };
}

/** Missing enrollment preserves established accounts. Unknown enrollment fails closed. */
export function isPendingSignup(auth: SignupAuth | null | undefined): boolean {
  const marker = auth?.selfServeSignup;
  return marker != null && (marker.version !== 1 || marker.status !== 'active');
}

/** Verified v1 accounts can prepare their real workspace without a paid subscription. */
export function canExploreSignupDashboard(auth: SignupAuth | null | undefined): boolean {
  return auth?.selfServeSignup?.version === 1
    && !!auth.selfServeSignup.emailVerifiedAt && Number.isFinite(Date.parse(auth.selfServeSignup.emailVerifiedAt))
    && ['pending_activation', 'cancelled'].includes(auth.selfServeSignup.status || '');
}

export function pendingSignupDestination(pathname: string, auth?: SignupAuth | null): string | null {
  if (canExploreSignupDashboard(auth)) return null;
  return ['/onboarding', '/walkthroughs'].includes(pathname.replace(/\/$/, '')) ? null : '/onboarding';
}

/** Activated enrollment is permanent, including when a later invoice needs attention. */
export function hasSignupSubscription(auth: SignupAuth | null | undefined): boolean {
  return auth?.selfServeSignup?.version === 1 && auth.selfServeSignup.status === 'active';
}

/** The browser mirrors sending restrictions; the server remains authoritative. */
export function isSignupSendingBlocked(auth: SignupAuth | null | undefined): boolean {
  return isPendingSignup(auth) || auth?.selfServeSignup?.environment === 'staging';
}
